import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import GatsbyImageWrapper from '../GatsbyImageWrapper';
import { Button } from '../primitives';


type ProductComparatorProps = {
    compareArray: any[];
    setCompareArray: (values: any[]) => void;
};

export default function ProductComparator(props: ProductComparatorProps) {
    const { compareArray, setCompareArray } = props;
    let productQuery = '/compare-product?products=';
    const { navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('templatePages');

    for (let i = 0; i < compareArray.length; i++) {
        i + 1 !== compareArray.length
            ? (productQuery += compareArray[i].product.code + '+')
            : (productQuery += compareArray[i].product.code);
    }

    return (
        <div className='compareSection'>
            {compareArray.map((compareItem, index) => (
                <React.Fragment key={index}>
                    <div className='product'>
                        {compareArray[index] && (
                            <span
                                className='removeProduct'
                                onClick={() => {
                                    compareArray.splice(index, 1);
                                    setCompareArray(
                                        compareArray.filter(
                                            (item) =>
                                                compareItem.product.code !==
                                                item.product.code
                                        )
                                    );
                                }}
                            >
                                X
                            </span>
                        )}
                        <GatsbyImageWrapper
                            fields={compareItem.product.fields}
                            imageIndex={1}
                        />
                        <span className='compareItemName'>
                            {compareItem.product.code}
                        </span>
                    </div>
                    {index < 2 && <p className='versus'>vs</p>}
                </React.Fragment>
            ))}

            {compareArray.length === 2 && (
                <div className='product'>
                    <img />
                </div>
            )}

            {compareArray.length === 1 && (
                <>
                    <div className='product'>
                        <img />
                    </div>
                    <p className='versus'>vs</p>
                    <div className='product'>
                        <img />
                    </div>
                </>
            )}

            <Button
                className='compareBtn'
                label={t('compare')}
                onClick={() => navigateTranslated(productQuery)}
            />
        </div>
    );
}
